import { create } from './Create/Create.i18n.en'

export const tankHistories = {
  create,
}
